import Img from 'gatsby-image';
import Image from './Image';

export default Image.withComponent(Img);



// WEBPACK FOOTER //
// ./src/components/GatsbyImage.js